import type {PopupMenuAttrs} from '@jetbrains/ring-ui/components/popup-menu/popup-menu'
import RingPopupMenu from '@jetbrains/ring-ui/components/popup-menu/popup-menu'

import type {PopupClass} from './Popup'
import {popupEnhancer} from './Popup'

export default popupEnhancer<PopupMenuAttrs, typeof RingPopupMenu>()(
  RingPopupMenu as PopupClass<PopupMenuAttrs, typeof RingPopupMenu>,
)
